import { useEffect, useRef } from "react";

// Utils
import { getCloudinaryRawUrl } from "@swiggy-private/js-utils";

// Constants
import { LOTTIE_ASSETS, SOUND_ASSETS } from "@swiggy-private/core-ui";

export const usePrefetchToingLottie = () => {
    const prefetchedRef = useRef<Set<string>>(new Set());

    useEffect(() => {
        const assets = [
            { id: SOUND_ASSETS.TRING_SOUND, key: "sound" },
            { id: LOTTIE_ASSETS.TOING_TRANSITION_LOTTIE_FILE_ID, key: "transition" },
            { id: LOTTIE_ASSETS.TOING_QUICK_TRACK_LOTTIE_FILE_ID, key: "quick-transition" },
        ];

        assets.forEach(({ id, key }) => {
            if (prefetchedRef.current.has(key)) return;
            prefetchedRef.current.add(key);
            const url = getCloudinaryRawUrl(id) || "";
            if (!url) {
                prefetchedRef.current.delete(key);
                return;
            }
            fetch(url).catch(() => {
                prefetchedRef.current.delete(key);
            });
        });
    }, []);
};
